import{View}from'./View';/**
 * A view describing how to display a collection of data as a Kanban board -
 * cards grouped into columns. Columns are either explicitly configured (see
 * `columns` below) or, when not configured, derived automatically from the
 * distinct values of statusDataPoint present in the fetched records.
 */export class Kanban extends View{}